export function checkMobileTest (rule, value, cb) {
    const regMobil = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[012345678]|18[0-9]|16[0-9]|19[0-9]|14[57])[0-9]{8}$/
   if (regMobil.test(value)) {
      return cb()
    }
    const error = new Error('请输入合法的手机号!')
     cb(error);
} 

export function checkSfzId (rule, value, cb) {
    const regMobil = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
   if (regMobil.test(value)) {
      return cb()
    }
    const error = new Error('请输入合法的身份证号码!');
     cb(error);
} 
